import classNames from 'clsx';

import { PageContentWrapperProps } from './PageContentWrapper.interface';
import { useStyles } from './PageContentWrapper.styles';

export default function PageContentWrapper({
  mainContent,
  sidebar,
  className,
  newAmbassadorStyle,
  isTravelResultsPage,
}: PageContentWrapperProps) {
  const classes = useStyles({ newAmbassadorStyle, isTravelResultsPage })();

  return (
    <div className={classNames(classes.root, className, 'PageContentWrapper')}>
      <div className={classes.content}>
        <main
          className={classNames(classes.mainContent, {
            [classes.densePaddingTop]: isTravelResultsPage,
          })}
        >
          {mainContent}
        </main>
        {sidebar && <aside className={classes.sidebar}>{sidebar}</aside>}
      </div>
    </div>
  );
}
